import React, { useEffect, useState } from "react";
import { PriceProvider } from "./Context/PriceCountext";
import Landing from "./Pages/Landing/Landing";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import MyOpinion from "./Pages/MyOpinion/MyOpinion";
import Support from "./Pages/Support/Support";
import FavoriteRestaurant from "./Pages/FavoriteRestaurant/FavoriteRestaurant";
import CooperationRequest from "./Pages/CooperationRequest/CooperationRequest";
import IntroductionCode from "./Pages/IntroductionCode/IntroductionCode";
import UserInformation from "./Pages/UserInformation/UserInformation";
import Orders from "./Pages/Orders/Orders";
import Shopping from "./Pages/Shopping/Shopping";
import Restaurants from "./Pages/Restaurants/Restaurants";
import HowToOrder from "./Pages/HowToOrder/HowToOrder";
import SupermarketsAround from "./Pages/SupermarketAround/SuperMarketsAround";
import SelectProductDirectly from "./Pages/SelectProductDirectly/SelectProductDirectly";
import Login from "./Pages/Login/Login";
import ConfirmCode from "./Pages/ConfirmCode/ConfirmCode";
import FurtherInformation from "./Pages/FurtherInformation/FurtherInformation";
import UpdateAddressInfo from "./Pages/UpdateAddressInfo/UpdateAddressInfo";
import SelectAddress from "./Pages/SelectAddress/SelectAddress";
import ChangeAddress from "./Pages/ChangeAddress/ChangeAddress";
import DiscountCode from "./Pages/DiscountCode/DiscountCode";
import UpdateAddress from "./Pages/UpdateAddress/UpdateAddress";
import { ToastContainer } from "react-toastify";
import Store from "./Pages/Store/Store";
import ProductDetail from "./Pages/ProductDetail/ProductDetail";
import RestaurantsList from "./Pages/RestaurantsList/RestaurantsList";
import ChooseDiscount from "./Pages/chooseDiscount/ChooseDiscount";
import FinalizePurchase from "./Pages/FinalizePurchase/FinalizePurchase";
import AllCommentsPage from "./Pages/AllCommentsPage/AllCommentsPage";
import Product from "./Pages/Product/Product";
import AboutSupplier from "./Pages/AboutSupplier/AboutSupplier";
import LastSeen from "./Pages/LastSeen/LastSeen";
import ClosedStore from "./Pages/ClosedStore/ClosedStore";
import Page404 from "./Pages/Page404/Page404";
import ShoppingPart from "./Pages/ShoppingPart/ShoppingPart";
import Microtransaction from "./Pages/Microtransaction/Microtransaction";
import MoreDiscountFood from "./Pages/MoreDiscountFood/MoreDiscountFood";
import MoreDiscountSupery from "./Pages/MoreDiscountSupery/MoreDiscountSupery";
import SeeMore from "./Pages/SeeMore/SeeMore";
import { getTokens, onMessageListener } from "./firebase";
import PayResult from "./PayResult/PayResult";
import GuidePage from "./Pages/GuidePage/GuidePage";
import LiveLocation from "./Pages/LiveLocation/LiveLocation";
import RequestDeliver from "./Pages/RequestDeliver/RequestDeliver";
import AboutUs from "./Pages/AboutUs/AboutUs";
import SubSet from "./Pages/SubSet/SubSet";
import AddNewAddress from "./Pages/AddNewAddress/AddNewAddress";
import AddNewAddressInfo from "./Pages/AddNewAddressInfo/AddNewAddressInfo";
import Iban from "./Component/Iban/Iban";
import ComingSoon from "./Pages/ComingSoon/ComingSoon";
import CurrentTaxi from "./Pages/Taxi/CurrentTaxi/CurrentTaxi";
import AimTaxi from "./Pages/Taxi/AimTaxi/AimTaxi";
import SecondAimTaxi from "./Pages/Taxi/SecondAimTaxi/SecondAimTaxi";
import RequestTaxi from "./Pages/Taxi/RequestTaxi/RequestTaxi";
import WaitingDrivers from "./Pages/Taxi/WaitingDrivers/WaitingDrivers";
import TaxiPanelLayout from "./Pages/TaxiPanel/TaxiPanelLayout";
import SupportChat from "./Pages/SupportChat/SupportChat";
import SupportNewMessage from "./Pages/SupportNewMessage/SupportNewMessage";
import SupportScore from "./Pages/SupportScore/SupportScore";
import { register } from "./serviceWorkerRegistration";
import OfflinePage from "./Pages/OfflinePage/OfflinePage";
import SubmitDeliverRequest from "./Pages/deliverRequest/SubmitDeliverRequest";
import DeliverRequest from "./Pages/deliverRequest/DeliverRequest";
import DeliveryLayout from "./Pages/deliverRequest/DeliveryLayout";
import Terms from "./Pages/Terms/Terms";
import ChoosePPLForTransaction from "./Pages/ChoosePPLForTransaction/ChoosePPLForTransaction";
import CreditTransfer from "./Pages/CreditTransfer/CreditTransfer";
import Chargewallet from "./Pages/Chargewallet/Chargewallet";
import { TransferReasonProvider } from "./Context/TransferReasonContext";
import FactureList from "./Pages/Facture/FactureList/FactureList";
import FactureByID from "./Pages/Facture/FactureList/FactureByID/FactureByID";
import { forgroundNotificationHandler } from "./Utils/Notification/ForGroundNotification";
import './App.css'
import BarestHelp from "./Pages/BarestHelp/BarestHelp";
import VoiceOrder from "./Pages/VoiceOrder/VoiceOrder";
const App = () => {
  const [isTokenFound, setTokenFound] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const isLogin = () => !!localStorage.getItem("JwtTokens");
  useEffect(() => {
    register({
      onUpdate: (registration) => {
        if (window.confirm("A new version is available. Reload to update?")) {
          window.location.reload();
        }
      },
    });
  }, []);
  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);
  useEffect(() => {
    if (!!localStorage.getItem("JwtTokens")) {
      if(!isTokenFound){getTokens(setTokenFound);}
    }
 if ("Notification" in window) {
      if (Notification.permission === "default") {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            if(!isTokenFound){getTokens(setTokenFound);}
          } else {
            console.log("Notification denied or dismissed");
          }
        });
      }
    }
    onMessageListener((payload) => {  
    forgroundNotificationHandler(payload);
  });
    
  }, []);
  
  const PublicRoute = ({ component, ...props }) => {
    return (
      <Route
        {...props}
        render={(props) => {
          if (isLogin()) {
            return <Redirect to={"/"} />;
          } else {
            return React.createElement(component, props);
          }
        }}
      ></Route>
    );
  };

  const PrivateRoute = ({ component, ...props }) => {
    return (
      <Route
        {...props}
        render={(props) => {
          if (isLogin()) {
            return React.createElement(component, props);
          } else {
            return <Redirect to={"/login"} />;
          }
        }}
      />
    );
  };
  if (!isOnline) {
    return <OfflinePage />;
  }
  return (
    <PriceProvider>
      <Router>
        <TransferReasonProvider>
          <Switch>
            <Route exact path={"/"} component={Landing} />
            <PrivateRoute exact path={"/myComments"} component={MyOpinion} />
            <PrivateRoute exact path={"/comingsoon"} component={ComingSoon} />
            <PrivateRoute exact path={"/support"} component={Support} />
            <PrivateRoute
              exact
              path={"/supportchat/:id"}
              component={SupportChat}
            />
            <PrivateRoute
              exact
              path={"/supportscore/:id"}
              component={SupportScore}
            />
            <PrivateRoute
              exact
              path={"/newmessage"}
              component={SupportNewMessage}
            />
            <PrivateRoute
              exact
              path={"/favorite"}
              component={FavoriteRestaurant}
            />
            <PrivateRoute exact path={"/subset"} component={SubSet} />
            <Route
              exact
              path={"/cooperationRequest"}
              component={CooperationRequest}
            />
            <Route exact path={"/aboutus"} component={AboutUs} />
            <PrivateRoute
              exact
              path={"/discountCode"}
              component={DiscountCode}
            />
            <PrivateRoute exact path={"/choose"} component={ChooseDiscount} />
            <PrivateRoute
              exact
              path={"/introductionCode"}
              component={IntroductionCode}
            />
            <PrivateRoute exact path={"/iban"} component={Iban} />
            <PrivateRoute
              exact
              path={"/userinformation"}
              component={UserInformation}
            />
            <PrivateRoute exact path={"/shopping"} component={Shopping} />
            <PrivateRoute exact path={"/shopp"} component={ShoppingPart} />
            <PrivateRoute exact path={"/restaurants"} component={Restaurants} />
            <PrivateRoute exact path={"/orders"} component={Orders} />
            <PrivateRoute exact path={"/supermarket"} component={HowToOrder} />
            <PrivateRoute
              exact
              path={"/supermarkets"}
              component={SupermarketsAround}
            />
            <PrivateRoute
              exact
              path={"/products"}
              component={SelectProductDirectly}
            />
            <PublicRoute exact path={"/login"} component={Login} />
            <Route exact path={"/confirm"} component={ConfirmCode} />
            <Route
              exact
              path={"/furtherInformation"}
              component={FurtherInformation}
            />
            <Route
              exact
              path={"/updateaddressinfo"}
              component={UpdateAddressInfo}
            />
            <Route
              exact
              path={"/addnewaddressinfo"}
              component={AddNewAddressInfo}
            />
            <Route exact path={"/addnewaddress"} component={AddNewAddress} />
            <Route exact path={"/selectAddress"} component={SelectAddress} />
            <PrivateRoute
              exact
              path={"/changeaddress"}
              component={ChangeAddress}
            />
            <PrivateRoute
              exact
              path={"/updateAddress"}
              component={UpdateAddress}
            />
            <PrivateRoute exact path={"/supplier/:id/"} component={Store} />
            <PrivateRoute
              exact
              path={"/supplier/:id/about/"}
              component={AboutSupplier}
            />
            <PrivateRoute
              exact
              path={"/restaurantlist"}
              component={RestaurantsList}
            />
            <PrivateRoute
              exact
              path={"/storeClosed/:id"}
              component={ClosedStore}
            />
            <PrivateRoute
              exact
              path={"/finalizepurchase"}
              component={FinalizePurchase}
            />
            <PrivateRoute
              exact
              path={"/supplier/:id/comments"}
              component={AllCommentsPage}
            />
            <PrivateRoute
              exact
              path={"/products/:category"}
              component={Product}
            />
            <PrivateRoute
              exact
              path={"/products/:category/:supId"}
              component={Product}
            />
            <PrivateRoute
              exact
              path={"/product/:id"}
              component={ProductDetail}
            />
            <PrivateRoute
              exact
              path={"/product/:id/:supId"}
              component={ProductDetail}
            />
            <PrivateRoute exact path={"/lastseen"} component={LastSeen} />
            <PrivateRoute
              exact
              path={"/morediscountfood"}
              component={MoreDiscountFood}
            />
            <PrivateRoute
              exact
              path={"/morediscountsupery"}
              component={MoreDiscountSupery}
            />
            <PrivateRoute
              exact
              path={"/microtransaction"}
              component={Microtransaction}
            />
            <PrivateRoute exact path={"/seemore"} component={SeeMore} />
            <PrivateRoute
              exact
              path={"/requestdeliver"}
              component={RequestDeliver}
            />
            <PrivateRoute
              exact
              path={"/newdeliveryrequest"}
              component={DeliverRequest}
            />
            <PrivateRoute
              exact
              path={"/deliveryrequest"}
              component={DeliveryLayout}
            />
            <PrivateRoute
              exact
              path={"/submitdeliveryrequest"}
              component={SubmitDeliverRequest}
            />
            <Route exact path={"/pay/:id"} component={PayResult} />
            <Route exact path={"/guidepage"} component={GuidePage} />
            <Route exact path={"/live"} component={LiveLocation} />

            <PrivateRoute exact path={"/current"} component={CurrentTaxi} />
            <PrivateRoute exact path={"/aim"} component={AimTaxi} />
            <PrivateRoute
              exact
              path={"/second-aim"}
              component={SecondAimTaxi}
            />
            <PrivateRoute
              exact
              path={"/request-taxi"}
              component={RequestTaxi}
            />

            <PrivateRoute
              exact
              path={"/waiting-drivers"}
              component={WaitingDrivers}
            />

            <PrivateRoute
              exact
              path={"/taxireqlist"}
              component={TaxiPanelLayout}
            />
            <PrivateRoute exact path={"/terms"} component={Terms} />
            <PrivateRoute
              exact
              path={"/ppltransaction"}
              component={ChoosePPLForTransaction}
            />
            <PrivateRoute
              exact
              path={"/chargewallet"}
              component={Chargewallet}
            />
            <PrivateRoute
              exact
              path={"/wallet/transfer_to/:userType/:userId"}
              component={CreditTransfer}
            />
            <PrivateRoute exact path={"/facturelist"} component={FactureList} />
            <PrivateRoute exact path={"/facture/:id"} component={FactureByID} />
            <PrivateRoute exact path={"/baresthelp"} component={BarestHelp} />
            <PrivateRoute exact path={"/voiceorder"} component={VoiceOrder} />

            <Route component={Page404} />
          </Switch>
        </TransferReasonProvider>
      </Router>
      <ToastContainer limit={3} autoClose={2000} />
    </PriceProvider>
  );
};
export default App;
